export const Auth = {
  CLIENT_ID: import.meta.env.VITE_AUTH_CLIENT_ID,
  SIGNIN_SIGNUP_POLICY_ID: import.meta.env
    .VITE_AUTH_SIGNIN_SIGNUP_POLICY_ID,
  INSTANCE: import.meta.env.VITE_AUTH_INSTANCE,
  AUTHORITY_DOMAIN: import.meta.env.VITE_AUTH_AUTHORITY_DOMAIN,
  DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
};
